import { Fragment, useEffect, useState } from "react";
import EventDateService from "../../../services/srv-event/EventDateService";
import { eventDateGridColumns } from "./EventDateGridColumns";
import CommonGrid from "../../../components/sys-common/CommonGrid";
import LoadingPanel from "../../../components/sys-toolbox/LoadingPanel";
import { t } from "i18next";

function EventDateList(props) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [dataState, setDataState] = useState({
    take: 10,
    skip: 0,
    filter: {
      logic: "or",
      filters: [
        {
          field: "etkinliK_TANIM_ID",
          operator: "eq",
          value: props.event.etkinliK_TANIM_ID,
        },
      ],
    },
  });

  useEffect(() => {
    getEventDates();
  }, [props.isAdded, dataState]);

  function getEventDates() {
    setLoading(true);
    EventDateService.getEventDates(dataState).then((data) => {
      setData(data?.data);
      setLoading(false);
    });
  }

  function addDate() {
    props.toggleDialogAddDate(props.setMode("add"));
  }

  function updateDate() {
    props.toggleDialogAddDate(props.setMode("update"));
  }

  return (
    <Fragment>
      {loading ? <LoadingPanel /> : null}{" "}
      <CommonGrid
        data={data}
        dataState={dataState}
        onDataStateChange={(event) => setDataState(event.dataState)}
        columns={eventDateGridColumns}
        addButton={{ text: t("add_date"), onClick: addDate }}
        editButton={{ text: t("update"), onClick: updateDate }}
        filterable={false}
        sortable={false}
        dataItemKey="etkinliK_TARIH_ID"
      />
    </Fragment>
  );
}

export { EventDateList };
